import type { LocaleLanguage } from "../types";

const LOCALE_LANGUAGE_SEGMENT_PATTERN = /^[a-z]{2}$/;

function isLocaleLanguage(value: string): value is LocaleLanguage {
  return LOCALE_LANGUAGE_SEGMENT_PATTERN.test(value);
}

export { isLocaleLanguage };
